'use client';

import { Box, Text, useToken } from '@skin-seoul/design-system';
interface SalePointCardProps {
  title: string;
  subtitle: string;
  icon?: React.ReactNode;
}
const SalePointCard = ({
  title,
  subtitle,
  icon
}: SalePointCardProps) => {
  return <Box background={`linear-gradient(138deg, #000 0%, #3D1690 99.9%)`} borderRadius="16px" height={{
    base: '120px',
    tablet: '145px'
  }} padding={{
    base: 4,
    tablet: 6
  }} width="100%" data-sentry-element="Box" data-sentry-component="SalePointCard" data-sentry-source-file="SalePointCard.tsx">
      {icon && <Box color="generic.0" marginBottom={{
      base: 2,
      tablet: 3
    }}>
          {icon}
        </Box>}
      <Text color="generic.0" textStyle="heading.h3" fontWeight="normal" marginBottom={{
      base: 2,
      tablet: 3
    }} data-sentry-element="Text" data-sentry-source-file="SalePointCard.tsx">
        {title}
      </Text>
      <Text color="neutral.100" textStyle={'paragraph.medium'} fontWeight="normal" maxWidth={{
      base: '100%',
      tablet: '200px'
    }} data-sentry-element="Text" data-sentry-source-file="SalePointCard.tsx">
        {subtitle}
      </Text>
    </Box>;
};
export default SalePointCard;